import { Text } from 'dripsy';
import { TextProps } from 'react-native';

export interface IBaseTextProps extends TextProps {}

export const BaseText = Text;
